/**
 * CPF/CNPJ: dígitos para API e máscara para UI.
 * Espelha `@cei-ufg/ngx-arquitetura-cei-frontend` (formatarCpfCnpj / CeiDocumentoFiscalPipe).
 */

export type DocumentoFiscalTipo = 'cpf' | 'cnpj' | 'cpf-cnpj';

export function apenasDigitosDocumento(value: string | null | undefined): string {
  return String(value ?? '').replace(/\D/g, '');
}

export function formatarCpf(value: string | null | undefined): string {
  const digitos = apenasDigitosDocumento(value).slice(0, 11);
  if (!digitos) {
    return '';
  }
  if (digitos.length <= 3) {
    return digitos;
  }
  if (digitos.length <= 6) {
    return `${digitos.slice(0, 3)}.${digitos.slice(3)}`;
  }
  if (digitos.length <= 9) {
    return `${digitos.slice(0, 3)}.${digitos.slice(3, 6)}.${digitos.slice(6)}`;
  }
  return `${digitos.slice(0, 3)}.${digitos.slice(3, 6)}.${digitos.slice(6, 9)}-${digitos.slice(9)}`;
}

export function formatarCnpj(value: string | null | undefined): string {
  const digitos = apenasDigitosDocumento(value).slice(0, 14);
  if (!digitos) {
    return '';
  }
  if (digitos.length <= 2) {
    return digitos;
  }
  if (digitos.length <= 5) {
    return `${digitos.slice(0, 2)}.${digitos.slice(2)}`;
  }
  if (digitos.length <= 8) {
    return `${digitos.slice(0, 2)}.${digitos.slice(2, 5)}.${digitos.slice(5)}`;
  }
  if (digitos.length <= 12) {
    return `${digitos.slice(0, 2)}.${digitos.slice(2, 5)}.${digitos.slice(5, 8)}/${digitos.slice(8)}`;
  }
  return `${digitos.slice(0, 2)}.${digitos.slice(2, 5)}.${digitos.slice(5, 8)}/${digitos.slice(8, 12)}-${digitos.slice(12)}`;
}

export function formatarCpfCnpj(value: string | null | undefined): string {
  const digitos = apenasDigitosDocumento(value);
  if (!digitos) {
    return '';
  }
  if (digitos.length <= 11) {
    return formatarCpf(digitos);
  }
  return formatarCnpj(digitos);
}

export function formatarDocumentoFiscal(
  value: string | null | undefined,
  tipo: DocumentoFiscalTipo,
): string {
  switch (tipo) {
    case 'cpf':
      return formatarCpf(value);
    case 'cnpj':
      return formatarCnpj(value);
    case 'cpf-cnpj':
    default:
      return formatarCpfCnpj(value);
  }
}
